// BuySalvageAutos — theme.js
(function () {
  'use strict';

  // Apply theme based on settings or stored preference
  const stored = localStorage.getItem('bsa-theme');
  if (stored) document.documentElement.dataset.theme = stored;

  // Loom video modal
  document.addEventListener('click', function (e) {
    const loom = e.target.closest('[data-loom-trigger]');
    if (!loom) return;
    const url = loom.getAttribute('data-loom-url');
    if (!url) return;
    openVideoModal(url);
  });

  function openVideoModal(url) {
    const modal = document.createElement('div');
    modal.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.8);z-index:999;display:flex;align-items:center;justify-content:center;padding:40px;cursor:pointer;';
    modal.innerHTML = `
      <div style="position:relative;width:100%;max-width:900px;aspect-ratio:16/9;background:#000;border-radius:12px;overflow:hidden;">
        <iframe src="${url}" frameborder="0" allow="autoplay;fullscreen" allowfullscreen
          style="position:absolute;inset:0;width:100%;height:100%;"></iframe>
      </div>
    `;
    modal.addEventListener('click', () => modal.remove());
    document.body.appendChild(modal);
  }

  // Reservation: add the configured deposit variant, then show the deposit summary cart.
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-reserve-btn]');
    if (!btn) return;
    e.preventDefault();

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    const productId = btn.dataset.productId;
    const vehicleUrl = btn.dataset.vehicleUrl || window.location.href;
    const properties = Object.fromEntries(Object.entries({
      'Vehicle': btn.dataset.vehicleTitle,
      'Vehicle URL': vehicleUrl,
      'Vehicle price': btn.dataset.vehiclePrice,
      'Deposit amount': btn.dataset.depositAmount,
      'Hold duration': btn.dataset.holdHours ? `${btn.dataset.holdHours} hours` : '',
      '_reserve_product_id': productId,
      '_reserve_vehicle_url': vehicleUrl,
      '_reserve_vehicle_price_cents': btn.dataset.vehiclePriceCents,
      '_reserve_started_at': new Date().toISOString(),
    }).filter(([, value]) => value));

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1, properties }],
      }),
    })
      .then(r => { if (!r.ok) throw new Error('Cart add failed'); return r.json(); })
      .then(() => { window.location.href = '/cart'; })
      .catch(err => console.error('Reserve failed', err));
  });

  document.addEventListener('click', function (e) {
    const tracked = e.target.closest('[data-bsa-track]');
    if (!tracked) return;
    trackEvent(tracked.dataset.bsaTrack, {
      productId: tracked.dataset.bsaProductId,
      productTitle: tracked.dataset.bsaProductTitle,
    });
  });

  document.addEventListener('toggle', function (e) {
    const tracked = e.target.closest?.('[data-bsa-track-open]');
    if (!tracked || !tracked.open) return;
    trackEvent(tracked.dataset.bsaTrackOpen, {
      productId: tracked.dataset.bsaProductId,
      productTitle: tracked.dataset.bsaProductTitle,
    });
  }, true);

  function trackEvent(name, payload = {}) {
    if (!name) return;
    const detail = {
      event: name,
      ...Object.fromEntries(Object.entries(payload).filter(([, value]) => value)),
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(detail);
    document.dispatchEvent(new CustomEvent('bsa:track', { detail }));
  }

  // Catalog sorting. Native Shopify sorts reload the collection with sort_by;
  // biggest discount is computed from the rendered card data for the current page.
  initCatalogSort();
  initDealMathCombobox();
  initInventoryReelDock();
  initExitTrustModal();

  function initExitTrustModal() {
    const productPage = document.querySelector('.bsa-pdp');
    const title = document.querySelector('.bsa-pdp-title')?.textContent?.trim();
    if (!productPage || !title) return;
    const stockNumber = productPage.dataset.stockNumber?.trim() || 'Not provided';

    const storageKey = 'bsa-exit-trust-modal-shown';
    if (sessionStorage.getItem(storageKey) === 'true') return;

    const onExitIntent = (event) => {
      if (event.relatedTarget || event.clientY > 0) return;
      showExitTrustModal(title, stockNumber, storageKey);
      document.removeEventListener('mouseout', onExitIntent);
    };
    document.addEventListener('mouseout', onExitIntent);
  }

  function showExitTrustModal(vehicleTitle, stockNumber, storageKey) {
    sessionStorage.setItem(storageKey, 'true');
    const message = encodeURIComponent(`Hi, I need this car today but I don't fully trust buying online. Can you show me the vehicle live on video and confirm the VIN, title, damage, and location before I put down a deposit? Vehicle: ${vehicleTitle}. Stock #: ${stockNumber}.`);
    const modal = document.createElement('div');
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'bsa-exit-trust-title');
    modal.style.cssText = 'position:fixed;inset:0;z-index:1000;display:grid;place-items:center;padding:22px;background:rgba(20,19,15,.62);backdrop-filter:blur(8px);';
    modal.innerHTML = `
      <div style="width:min(520px,100%);border:1px solid rgba(20,19,15,.14);border-radius:22px;background:#f6f4ee;color:#14130f;box-shadow:0 24px 80px rgba(0,0,0,.28);padding:24px;">
        <div style="display:flex;justify-content:space-between;gap:16px;align-items:flex-start;margin-bottom:14px;">
          <div style="font-family:var(--font-mono);font-size:11px;text-transform:uppercase;letter-spacing:.08em;color:#8a8172;">Before you leave</div>
          <button type="button" data-bsa-exit-close aria-label="Keep browsing" style="width:34px;height:34px;border:1px solid rgba(20,19,15,.14);border-radius:999px;background:transparent;cursor:pointer;font-size:22px;line-height:1;">×</button>
        </div>
        <h2 id="bsa-exit-trust-title" style="margin:0 0 12px;font-size:34px;line-height:.98;letter-spacing:-.04em;font-weight:600;">Wait — not ready to trust us yet?</h2>
        <p style="margin:0 0 20px;color:#5d574d;font-size:15px;line-height:1.5;">Good instinct. Don’t put down a deposit blind. We can show you the vehicle live on video and confirm the VIN, title, damage, and location first.</p>
        <div style="display:grid;gap:10px;">
          <a data-bsa-exit-cta data-bsa-track="exit_video_walkaround_click" href="#" target="_blank" rel="noopener" style="display:inline-flex;align-items:center;justify-content:center;min-height:46px;border-radius:10px;background:#ff6700;color:#1a1408;text-decoration:none;font-weight:700;">Show me the car live</a>
          <button type="button" data-bsa-exit-close style="min-height:44px;border:1px solid rgba(20,19,15,.16);border-radius:10px;background:transparent;color:#14130f;font-weight:600;cursor:pointer;">Keep browsing</button>
        </div>
      </div>
    `;
    modal.querySelector('[data-bsa-exit-cta]')?.setAttribute('href', `https://wa.me/17867476090?text=${message}`);
    const close = () => modal.remove();
    modal.querySelectorAll('[data-bsa-exit-close]').forEach((button) => button.addEventListener('click', close));
    modal.addEventListener('click', (event) => { if (event.target === modal) close(); });
    document.addEventListener('keydown', function onKeydown(event) {
      if (event.key !== 'Escape') return;
      close();
      document.removeEventListener('keydown', onKeydown);
    });
    document.body.appendChild(modal);
  }


  function initDealMathCombobox() {
    document.querySelectorAll('[data-bsa-deal-math]').forEach((section) => {
      const input = section.querySelector('[data-bsa-deal-stock-input]');
      const status = section.querySelector('[data-bsa-deal-status]');
      const cta = section.querySelector('[data-bsa-deal-cta]');
      const items = Array.from(section.querySelectorAll('[data-bsa-deal-item]'))
        .map((item) => ({ ...item.dataset, normalizedStock: normalizeStock(item.dataset.stock) }))
        .filter((item) => item.normalizedStock);
      if (!input || !items.length) return;

      const byStock = new Map(items.map((item) => [item.normalizedStock, item]));

      input.addEventListener('input', () => {
        const item = byStock.get(normalizeStock(input.value));
        if (!item) {
          if (status) status.textContent = input.value.trim()
            ? 'Choose a stock number from the available list.'
            : 'Choose an available stock number to update the math.';
          resetDealCta(cta);
          return;
        }
        updateDealMath(section, item);
        if (status) status.textContent = `${item.stock} selected — numbers updated.`;
        if (cta && item.url) {
          cta.href = item.url;
          cta.textContent = 'View selected vehicle →';
        }
      });
    });
  }

  function updateDealMath(section, item) {
    const dealerFeeCents = Number(section.dataset.dealerFeeCents) || 0;
    const priceCents = Number(item.priceCents) || 0;
    const acvCents = Number(item.acvCents) || 0;
    const knownSubtotalCents = priceCents + dealerFeeCents;
    const priceGapCents = acvCents - knownSubtotalCents;

    setText(section, '[data-bsa-deal-vehicle-id]', `${item.stock} · ${(item.title || 'Vehicle').toUpperCase()}`);
    setText(section, '[data-bsa-deal-price]', formatMoneyCents(priceCents));
    setText(section, '[data-bsa-deal-known]', formatMoneyCents(knownSubtotalCents));
    setText(section, '[data-bsa-deal-acv]', acvCents > 0 ? formatMoneyCents(acvCents) : 'Not available');

    const gapWrap = section.querySelector('[data-bsa-deal-gap-wrap]');
    if (gapWrap) gapWrap.hidden = priceGapCents <= 0;
    setText(section, '[data-bsa-deal-gap]', formatMoneyCents(Math.max(priceGapCents, 0)));
  }

  function resetDealCta(cta) {
    if (!cta) return;
    cta.href = cta.dataset.defaultUrl || '/collections/all';
    cta.textContent = `${cta.dataset.defaultText || 'Browse vehicles'} →`;
  }

  function setText(root, selector, value) {
    const target = root.querySelector(selector);
    if (target) target.textContent = value;
  }

  function normalizeStock(value) {
    return String(value || '').trim().replace(/[^a-z0-9]/gi, '').toUpperCase();
  }

  function formatMoneyCents(cents) {
    const value = Number(cents) / 100;
    if (!Number.isFinite(value)) return '';
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(value);
  }

  function initCatalogSort() {
    const selects = document.querySelectorAll('[data-bsa-sort-select]');
    if (!selects.length) return;

    const params = new URLSearchParams(window.location.search);
    const activeCustomSort = params.get('sort');
    const activeShopifySort = params.get('sort_by');
    const sortByToOption = {
      'price-ascending': 'price-asc',
      'price-descending': 'price-desc',
      'created-descending': 'newest',
      'manual': 'best',
    };
    const activeValue = activeCustomSort === 'savings'
      ? 'savings'
      : (sortByToOption[activeShopifySort] || 'best');

    selects.forEach((select) => {
      select.value = activeValue;
      select.addEventListener('change', () => handleCatalogSort(select.value));
    });

    if (activeValue === 'savings') sortVisibleVehicleCards('savings');
    if (activeValue === 'best') sortVisibleVehicleCards('sales-score');
  }

  function handleCatalogSort(value) {
    if (value === 'savings') {
      const url = new URL(window.location.href);
      url.searchParams.set('sort', 'savings');
      url.searchParams.delete('sort_by');
      url.searchParams.delete('page');
      window.history.replaceState({}, '', url.toString());
      sortVisibleVehicleCards('savings');
      return;
    }

    const optionToSortBy = {
      'price-asc': 'price-ascending',
      'price-desc': 'price-descending',
      'newest': 'created-descending',
      'best': 'manual',
    };
    const url = new URL(window.location.href);
    url.searchParams.delete('sort');
    url.searchParams.delete('page');
    url.searchParams.set('sort_by', optionToSortBy[value] || 'manual');
    window.location.href = url.toString();
  }

  function sortVisibleVehicleCards(sortKey) {
    const grid = document.querySelector('.bsa-grid');
    if (!grid) return;

    const cards = Array.from(grid.querySelectorAll('[data-bsa-vehicle-card]'));
    if (cards.length < 2) return;

    const sortedCards = cards.sort((a, b) => {
      if (sortKey === 'sales-score') {
        return availabilityRank(b) - availabilityRank(a)
          || numericData(b, 'salesScore') - numericData(a, 'salesScore')
          || numericData(b, 'savings') - numericData(a, 'savings')
          || numericData(b, 'created') - numericData(a, 'created');
      }
      if (sortKey === 'savings') {
        return numericData(b, 'savings') - numericData(a, 'savings');
      }
      return 0;
    });
    const pagination = grid.querySelector('.bsa-pagination');
    sortedCards.forEach((card) => grid.insertBefore(card, pagination));
  }

  function numericData(element, key) {
    const value = Number(element.dataset[key]);
    return Number.isFinite(value) ? value : 0;
  }

  function availabilityRank(element) {
    const status = element.dataset.availability;
    if (status === 'listed') return 3;
    if (status === 'on_hold') return 2;
    return 1;
  }

  function initInventoryReelDock() {
    const dock = document.querySelector('[data-bsa-reel-dock]');
    const openButton = document.querySelector('[data-bsa-reel-dock-open]');
    if (!dock || !openButton) return;

    const items = Array.from(dock.querySelectorAll('[data-bsa-reel-item]'))
      .map((item) => ({ ...item.dataset }))
      .filter((item) => item.reelUrl);
    if (!items.length) return;

    const video = dock.querySelector('[data-bsa-reel-dock-video]');
    const title = dock.querySelector('[data-bsa-reel-dock-title]');
    const meta = dock.querySelector('[data-bsa-reel-dock-meta]');
    const price = dock.querySelector('[data-bsa-reel-dock-price]');
    const image = dock.querySelector('[data-bsa-reel-dock-image]');
    const link = dock.querySelector('[data-bsa-reel-dock-link]');
    const status = dock.querySelector('[data-bsa-reel-dock-status]');
    const count = dock.querySelector('[data-bsa-reel-count]');
    const hiddenKey = 'bsa-reel-dock-hidden';
    const positionKey = 'bsa-reel-dock-position';
    let index = 0;

    dock.querySelector('[data-bsa-reel-next]')?.addEventListener('click', () => setReel(index + 1, true));
    dock.querySelector('[data-bsa-reel-prev]')?.addEventListener('click', () => setReel(index - 1, true));
    dock.querySelector('[data-bsa-reel-dock-close]')?.addEventListener('click', () => {
      window.localStorage.setItem(hiddenKey, 'true');
      dock.hidden = true;
      openButton.hidden = false;
      video?.pause();
    });
    openButton.addEventListener('click', () => {
      window.localStorage.setItem(hiddenKey, 'false');
      openDock();
    });

    enableReelDockDrag(dock, dock.querySelector('[data-bsa-reel-drag]'), positionKey);
    setReel(0, false);
    if (window.localStorage.getItem(hiddenKey) === 'false') {
      openDock();
    } else {
      openButton.hidden = false;
    }

    function openDock() {
      dock.hidden = false;
      openButton.hidden = true;
      applySavedDockPosition(dock, positionKey);
      playDockVideo(video);
    }

    function setReel(nextIndex, shouldPlay = false) {
      index = (nextIndex + items.length) % items.length;
      const item = items[index];
      if (video && video.src !== item.reelUrl) video.src = item.reelUrl;
      if (title) title.textContent = item.title || 'Vehicle reel';
      if (meta) meta.textContent = [item.stock ? `Stock #${item.stock}` : '', item.mileage ? `${formatNumber(item.mileage)} mi` : '', item.location || ''].filter(Boolean).join(' · ');
      if (price) price.textContent = item.price ? formatMoney(Number(item.price)) : '';
      if (status) status.textContent = item.status || 'Available';
      if (image) {
        image.src = item.image || '';
        image.alt = item.title || 'Vehicle';
        image.hidden = !item.image;
      }
      if (link) {
        link.href = item.url || '#';
        link.hidden = !item.url;
      }
      if (count) count.textContent = `${index + 1} / ${items.length}`;
      if (shouldPlay) playDockVideo(video);
    }
  }

  function playDockVideo(video) {
    if (!video) return;
    video.controls = true;
    video.autoplay = true;
    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('autoplay', '');
    video.setAttribute('playsinline', '');
    video.play().catch(() => {
      // If autoplay is blocked, the controls remain visible.
    });
  }

  function formatMoney(value) {
    if (!Number.isFinite(value)) return '';
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(value);
  }

  function formatNumber(value) {
    const numeric = Number(value);
    if (!Number.isFinite(numeric)) return '';
    return new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(numeric);
  }

  function enableReelDockDrag(dock, handle, positionKey) {
    if (!dock || !handle) return;
    applySavedDockPosition(dock, positionKey);
    let dragState = null;

    handle.addEventListener('pointerdown', (event) => {
      if (event.target.closest('button')) return;
      const rect = dock.getBoundingClientRect();
      dragState = {
        offsetX: event.clientX - rect.left,
        offsetY: event.clientY - rect.top,
      };
      handle.setPointerCapture?.(event.pointerId);
      dock.classList.add('is-dragging');
    });

    handle.addEventListener('pointermove', (event) => {
      if (!dragState) return;
      const width = dock.offsetWidth;
      const height = dock.offsetHeight;
      const left = clamp(event.clientX - dragState.offsetX, 8, window.innerWidth - width - 8);
      const top = clamp(event.clientY - dragState.offsetY, 8, window.innerHeight - height - 8);
      dock.style.left = `${left}px`;
      dock.style.top = `${top}px`;
      dock.style.right = 'auto';
      dock.style.bottom = 'auto';
    });

    handle.addEventListener('pointerup', () => {
      if (!dragState) return;
      dragState = null;
      dock.classList.remove('is-dragging');
      window.localStorage.setItem(positionKey, JSON.stringify({ left: dock.style.left, top: dock.style.top }));
    });
  }

  function applySavedDockPosition(dock, positionKey) {
    if (!dock || window.innerWidth < 760) return;
    try {
      const saved = JSON.parse(window.localStorage.getItem(positionKey) || 'null');
      if (!saved?.left || !saved?.top) return;
      dock.style.left = saved.left;
      dock.style.top = saved.top;
      dock.style.right = 'auto';
      dock.style.bottom = 'auto';
    } catch {
      // Ignore bad saved positions.
    }
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  // Product gallery lightbox with optional desktop reel panel.
  document.querySelectorAll('[data-bsa-gallery]').forEach(initProductGallery);

  function initProductGallery(gallery) {
    const triggers = Array.from(gallery.querySelectorAll('.bsa-pdp-media-trigger'));
    const lightbox = gallery.parentElement.querySelector('[data-bsa-media-lightbox]');
    if (!triggers.length || !lightbox) return;

    const imageEl = lightbox.querySelector('[data-bsa-lightbox-image]');
    const countEl = lightbox.querySelector('[data-bsa-media-count]');
    const thumbButtons = Array.from(lightbox.querySelectorAll('[data-bsa-lightbox-thumbs] [data-media-index]'));
    const reelFrame = lightbox.querySelector('[data-bsa-reel-frame]');
    const reelUrl = reelFrame?.getAttribute('data-reel-url') || gallery.getAttribute('data-reel-url');
    // The compact gallery can intentionally render only a subset of the
    // product images. The lightbox thumb rail is the canonical, complete
    // source so the counter and navigation always cover every product image.
    const mediaSourceTriggers = thumbButtons.length
      ? thumbButtons
      : (gallery.querySelectorAll('.bsa-pdp-media-trigger.thumb').length
        ? Array.from(gallery.querySelectorAll('.bsa-pdp-media-trigger.thumb'))
        : triggers);
    const media = mediaSourceTriggers
      .filter((trigger) => trigger.dataset.fullSrc)
      .map((trigger) => ({
        src: trigger.dataset.fullSrc,
        alt: trigger.querySelector('img')?.getAttribute('alt') || '',
      }));
    let activeIndex = 0;
    let reelLoaded = false;

    if (reelUrl) lightbox.classList.add('has-reel');

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        openAt(Number(trigger.dataset.mediaIndex || 0));
      });
    });

    thumbButtons.forEach((button) => {
      button.addEventListener('click', () => {
        setActive(Number(button.dataset.mediaIndex || 0));
      });
    });

    lightbox.querySelector('[data-bsa-media-prev]')?.addEventListener('click', () => {
      setActive(activeIndex - 1);
    });
    lightbox.querySelector('[data-bsa-media-next]')?.addEventListener('click', () => {
      setActive(activeIndex + 1);
    });
    lightbox.querySelectorAll('[data-bsa-lightbox-close]').forEach((button) => {
      button.addEventListener('click', closeLightbox);
    });

    document.addEventListener('keydown', (event) => {
      if (!lightbox.classList.contains('open')) return;
      if (event.key === 'Escape') closeLightbox();
      if (event.key === 'ArrowLeft') setActive(activeIndex - 1);
      if (event.key === 'ArrowRight') setActive(activeIndex + 1);
    });

    function openAt(index) {
      setActive(index);
      lightbox.classList.add('open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      loadReel();
    }

    function closeLightbox() {
      lightbox.classList.remove('open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      unloadReel();
    }

    function setActive(index) {
      if (!media.length) return;
      activeIndex = (index + media.length) % media.length;
      const item = media[activeIndex];
      imageEl.src = item.src;
      imageEl.alt = item.alt;
      if (countEl) countEl.textContent = `${activeIndex + 1} / ${media.length}`;
      thumbButtons.forEach((button) => {
        button.classList.toggle('is-active', Number(button.dataset.mediaIndex) === activeIndex);
      });
      triggers.forEach((button) => {
        button.classList.toggle('is-active', Number(button.dataset.mediaIndex) === activeIndex);
      });

      // Keep the selected image in view as the customer moves through the
      // complete thumbnail rail with the arrows or keyboard.
      const activeThumb = thumbButtons.find(
        (button) => Number(button.dataset.mediaIndex) === activeIndex,
      );
      activeThumb?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }

    function loadReel() {
      if (!reelFrame || !reelUrl || reelLoaded) return;
      const embedUrl = toEmbeddableReelUrl(reelUrl);
      reelFrame.innerHTML = '';
      if (isDirectVideoUrl(embedUrl)) {
        const video = document.createElement('video');
        video.src = embedUrl;
        video.controls = true;
        video.autoplay = true;
        video.muted = true;
        video.defaultMuted = true;
        video.loop = true;
        video.playsInline = true;
        video.preload = 'metadata';
        video.setAttribute('muted', '');
        video.setAttribute('autoplay', '');
        video.setAttribute('playsinline', '');
        video.title = 'Vehicle reel';
        reelFrame.appendChild(video);
        video.play().catch(() => {
          // Browser autoplay policies can still block playback in edge cases.
          // Controls remain visible so the customer can start/unmute manually.
        });
        reelLoaded = true;
        return;
      }
      const iframe = document.createElement('iframe');
      iframe.src = embedUrl;
      iframe.loading = 'lazy';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      iframe.allowFullscreen = true;
      iframe.title = 'Vehicle reel';
      reelFrame.appendChild(iframe);
      reelLoaded = true;
    }

    function unloadReel() {
      if (!reelFrame || !reelLoaded) return;
      reelFrame.innerHTML = '<div class="bsa-media-reel-placeholder">Reel loads when gallery opens</div>';
      reelLoaded = false;
    }
  }

  function toEmbeddableReelUrl(url) {
    try {
      const parsed = new URL(url);
      if (parsed.hostname.includes('instagram.com')) {
        const match = parsed.pathname.match(/\/(reel|p|tv)\/([^/]+)/);
        if (match) return `https://www.instagram.com/${match[1]}/${match[2]}/embed`;
      }
      return parsed.toString();
    } catch {
      return url;
    }
  }

  function isDirectVideoUrl(url) {
    try {
      const parsed = new URL(url);
      return /\.(mp4|mov|m4v|webm)(?:$|\?)/i.test(parsed.pathname) ||
        (parsed.hostname.includes('cdn.shopify.com') && parsed.pathname.includes('/videos/'));
    } catch {
      return /\.(mp4|mov|m4v|webm)(?:$|\?)/i.test(String(url));
    }
  }

})();
